import { useGetRiskFactors } from '@/queries/risk.queries';

export default function useRiskFactorsSummary() {
  const { data: riskFactorsHookData } = useGetRiskFactors();

  const overallFactors = riskFactorsHookData?.factorsPerCancer.find(({ cancerType }) => cancerType === 'overall');

  const riskFactorsSummary = overallFactors?.riskFactorsSummary ?? {
    negativeImpactRiskFactorsCount: 0,
    positiveImpactRiskFactorsCount: 0,
    riskFactorsCount: 0,
  };

  const modifiableRiskFactorCount = overallFactors?.modifiableRiskFactorCount ?? 0;

  return { riskFactorsSummary, riskFactorsHookData, overallFactors, modifiableRiskFactorCount };
}
